import { el } from 'redom';

import './index.scss';

const PLACEHOLDER = 'Tell AI what to do with the selection';

class AIInstructionPanel {

  constructor(configuration) {

    this.onSubmit = configuration.onSubmit;
    this.onCapture = configuration.onCapture;
    this.onConfirm = configuration.onConfirm;
    this.onCancel = configuration.onCancel;

    this.locked = false;

    this.handleFocus = this.handleFocus.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleLockedKeyDown = this.handleLockedKeyDown.bind(this);

    this.input = el('.ai-instruction-input-field');
    this.input.setAttribute('contenteditable', 'true');
    this.input.setAttribute('spellcheck', 'false');
    this.input.setAttribute('role', 'textbox');
    this.input.setAttribute('data-placeholder', PLACEHOLDER);

    this.input.addEventListener('focus', this.handleFocus);
    this.input.addEventListener('input', this.handleInput);
    this.input.addEventListener('keydown', this.handleKeyDown);

    this.inputSection = el('.ai-instruction-input-section', [this.input]);

    this.el = el('.ai-instruction-panel-main', [this.inputSection]);

    this.updateEmptyState();

  }

  getValue() {

    return this.input.textContent;

  }

  containsTarget(target) {

    return this.el.contains(target);

  }

  handleFocus() {

    if (typeof this.onCapture === 'function') {
      this.onCapture();
    }

  }

  handleInput() {

    this.updateEmptyState();

  }

  updateEmptyState() {

    if (this.getValue() === '') {
      this.input.classList.add('empty');
      return;
    }

    this.input.classList.remove('empty');

  }

  handleKeyDown(event) {

    if (this.locked === true) {
      return;
    }

    if (event.ctrlKey === true || event.metaKey === true || event.altKey === true) {
      return;
    }

    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      const trimmed = this.getValue().trim();
      if (trimmed === '') {
        return;
      }
      this.lockInput();
      this.onSubmit(trimmed);
      return;
    }

    if (event.key === 'Escape') {
      this.disengageInput();
      return;
    }

    event.stopPropagation();

  }

  handleLockedKeyDown(event) {

    event.preventDefault();
    event.stopPropagation();

    if (event.key === 'Escape') {
      if (typeof this.onCancel === 'function') {
        this.onCancel();
      }
      return;
    }

    if (event.key === 'Enter') {
      if (typeof this.onConfirm === 'function') {
        this.onConfirm();
      }
      return;
    }

  }

  lockInput() {

    this.locked = true;
    this.input.setAttribute('contenteditable', 'false');
    document.addEventListener('keydown', this.handleLockedKeyDown, true);

  }

  unlockInput() {

    if (this.locked === false) {
      return;
    }

    this.locked = false;
    this.input.setAttribute('contenteditable', 'true');
    document.removeEventListener('keydown', this.handleLockedKeyDown, true);

  }

  focus() {

    this.input.focus();
    this.placeCaretAtEnd();

  }

  placeCaretAtEnd() {

    const selection = window.getSelection();

    if (selection === null) {
      return;
    }

    const range = document.createRange();
    range.selectNodeContents(this.input);
    range.collapse(false);
    selection.removeAllRanges();
    selection.addRange(range);

  }

  disengageInput() {

    this.input.blur();

  }

  clearInput() {

    this.unlockInput();
    this.input.textContent = '';
    this.updateEmptyState();
    this.input.blur();

  }

  onunmount() {

    document.removeEventListener('keydown', this.handleLockedKeyDown, true);
    this.input.removeEventListener('focus', this.handleFocus);
    this.input.removeEventListener('input', this.handleInput);
    this.input.removeEventListener('keydown', this.handleKeyDown);

  }

}

export default AIInstructionPanel;
